export default "__VITE_ASSET__BFa091lu__"